import { isArray } from 'lodash';

const quickFixText = (text: string | null | string[]): string => {
  if (!text) {
    return '';
  }

  if (isArray(text)) {
    return text.join(', ');
  }

  if (typeof text === 'string') {
    return text.toUpperCase();
  }

  return '';
};

export const textComparator = (
  a: string | null,
  b: string | null,
  nodeA: any,
  nodeB: any,
  isDescending: boolean
) => {
  // console.log('textComparator', a, b, nodeA, nodeB, isDescending);

  a = quickFixText(a);
  b = quickFixText(b);

  const lenA = a.length;
  const lenB = b.length;
  const minLen = lenA < lenB ? lenA : lenB;
  let i = 0;
  for (; i < minLen; ++i) {
    const ca = a.charCodeAt(i);
    const cb = b.charCodeAt(i);

    if (ca > cb) return 1;
    else if (ca < cb) return -1;
  }
  if (lenA === lenB) return 0;
  return lenA > lenB ? 1 : -1;
};
